import React from 'react'
import { Link } from 'react-router-dom'
import { useStoreView } from 'hooks/useStoreView'
import { ReactComponent as LogoSvg } from 'resources/svg/logo.svg'
import LogoLivBrite from 'app/livbrite/resources/images/livBrite_logo.png'
import { MainMenu } from './components/MainMenu'
import { Actions } from '../Actions'
import { AccountLinks } from './../AccountLinks'
import { Container, Logo, AbsoluteLogo, MainSection } from './components/Styled'
import { PromotionalBanner } from 'components/PromotionalBanner'

export const DesktopVersion = () => {
  const { isSofiaAndGrace, isLivBrite } = useStoreView()

  return (
    <Container
      isLivBrite={isLivBrite}
    >
      <div>
        <AccountLinks />
      </div>
      <MainSection>
        {isSofiaAndGrace ? (
          <Logo>
            <Link to='/'>
              <LogoSvg />
            </Link>
          </Logo>
        ) : (
          <AbsoluteLogo>
            <Link to='/'>
              <img src={LogoLivBrite} alt='LivBrite' />
            </Link>
          </AbsoluteLogo>
        )}
        <MainMenu />
        <Actions />
      </MainSection>
      <PromotionalBanner />
    </Container>
  )
}
